import { render, staticRenderFns } from "./SecondaryDrawer.vue?vue&type=template&id=bbe5575a&"
import script from "./SecondaryDrawer.vue?vue&type=script&lang=js&"
export * from "./SecondaryDrawer.vue?vue&type=script&lang=js&"
import style0 from "./SecondaryDrawer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VList,VListItem,VListItemContent})
